import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
// import storiumWorkboardLibrary from '@kristjan87/storium-workboard-library';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura'
import 'primeicons/primeicons.css';   
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import Tooltip from 'primevue/tooltip';
const app = createApp(App)
app.directive('tooltip', Tooltip);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.my-app-dark'
        }
    }
});
// Set a global property
app.config.globalProperties.$fetchIp = process.env.VUE_APP_MAIN_URL;
// app.use(storiumWorkboardLibrary);
app.use(router)
app.use(ConfirmationService)
app.use(ToastService)

app.mount('#app')
